<template lang="pug">
  div(@click="clickOutside")
    v-container.pt-6(fluid)
      v-form(ref="form")
        div.px-10
          v-row.mb-2(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="goBack" height)
                v-icon(color="neutral700" :size="24") mdi-arrow-left
            v-col.ml-3
              .text-2xl.font-semibold.neutral700--text Stock update
          v-divider
          v-row.mt-2
            v-col(cols="6" md="4")
              v-row.py-1(no-gutters align="center")
                v-col(cols="3")
                  div.text-sm.font-semibold.neutral500--text Seller
                v-col(cols="9")
                  medication-sold-by-dropdown(v-model="seller" attach show-add-seller :error="showSellerError" @closed="showSellerError = false")
            v-col(cols="6" md="4")
              v-row.py-1(no-gutters align="center")
                v-col(cols="3")
                  div.text-sm.font-semibold.neutral500--text Invoice date
                v-col(cols="9")
                  y-dialog(v-model="showInvoicePicker" width='360px' persistent content-class="round-xl")
                    template(v-slot:activator='{ on }')
                      v-text-field.text-sm.round-xl.date-field(v-model="invoiceDateField" placeholder="Invoice date" outlined dense height="48" readonly :rules="requiredInvoice ? rules.not_empty : []" hide-details="auto" v-on="on" clearable)
                        template(v-slot:append)
                          eva-icon(name="calendar-outline" fill="#848484")
                    v-card
                      v-card-text.px-2.pt-2.pb-0
                        yc-date-picker(:parentDate.sync="invoice.record_date" color="info")
                      v-card-actions.px-4.pb-4
                        v-row(no-gutters)
                          v-col.pr-2
                            v-btn.button-sm(color="neutral700" block dark outlined depressed @click="showInvoicePicker = false") {{ $t('cancel') }}
                          v-col.pl-2
                            v-btn.button-sm(color="neutral700" block depressed dark @click="pickDate('invoiceDateField', 'showInvoicePicker', invoice.record_date)") {{ $t('select') }}
              v-row.py-1(no-gutters align="center")
                v-col(cols="3")
                  div.text-sm.font-semibold.neutral500--text Invoice no.
                v-col(cols="9")
                  v-text-field.text-sm.round-xl(v-model="invoice.invoice_no" placeholder="Invoice number" outlined dense height="48" :rules="requiredInvoice ? rules.not_empty : []" hide-details="auto")
        v-divider.mt-4.neutral400
        div
          v-data-table(:headers="headers" :items="stocks" hide-default-footer disable-sort loader-height="2" :items-per-page="-1")
            //- Number
            template(v-slot:item.number="{ item, index }")
              div {{ index + 1 }}
            //- Name
            template(v-slot:item.name="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                medication-stock-dropdown(v-if="item.editable" v-model="item.medicine")
                div(v-else-if="item.medicine") {{ item.medicine.name }}
            //- Quantity
            template(v-slot:item.quantity="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.quantity" placeholder="0" outlined dense height="48" type="number" :rules="rules.has_quantity" hide-details @input="calculateAmount(item, 'quantity')")
                div(v-else-if="item.quantity") {{ item.quantity }}
            //- Rate
            template(v-slot:item.rate="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.rate" placeholder="0.00" outlined dense height="48" type="number" :prefix="$currency.symbol" :rules="rules.has_price" hide-details @input="calculateAmount(item, 'rate')")
                div(v-else-if="item.rate") {{ $currency.symbol }} {{ item.rate }}
            //- UOM
            template(v-slot:item.uom="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                div(v-if="item.medicine && item.medicine.product && item.medicine.product.uom") {{ item.medicine.product.uom }}
            //- Expiry date
            template(v-slot:item.expiry_date="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                y-dialog(v-if="item.editable" v-model="item.showExpiredPicker" width='360px' persistent content-class="round-xl")
                  template(v-slot:activator='{ on }')
                    v-text-field.text-sm.round-xl.date-field(v-model="item.expiryDateField" placeholder="Expiry date" outlined dense height="48" readonly hide-details v-on="on" clearable)
                      template(v-slot:append)
                        eva-icon(name="calendar-outline" fill="#848484")
                  v-card
                    v-card-text.px-2.pt-2.pb-0
                      yc-date-picker(:parentDate.sync="item.selectedExpiryDate" color="info")
                    v-card-actions.px-4.pb-4
                      v-row(no-gutters)
                        v-col.pr-2
                          v-btn.button-sm(color="neutral700" block dark outlined depressed @click="item.showExpiredPicker = false") {{ $t('cancel') }}
                        v-col.pl-2
                          v-btn.button-sm(color="neutral700" block depressed dark @click="pickItemDate(item)") {{ $t('select') }}
                div(v-else-if="item.expiryDateField") {{ item.expiryDateField }}
            //- Batch no
            template(v-slot:item.batch_no="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.batch_no" placeholder="Batch number" outlined dense height="48" hide-details)
                div(v-else-if="item.batch_no") {{ item.batch_no }}
            //- Total
            template(v-slot:item.total="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.total" placeholder="100" outlined dense height="48" type="number" :prefix="$currency.symbol" :rules="rules.has_price" hide-details @input="calculateAmount(item, 'total')")
                div(v-else-if="item.total") {{ $currency.symbol }} {{ item.total }}
            //- Delete
            template(v-slot:item.action="{ item, index }")
              template(v-if="isCompletedItem(item)")
                v-btn(icon @click.stop="deleteItem(index)")
                  v-icon(size="18") $yzi-trash-03
            //- No data
            template(v-slot:no-data)
              div

        v-row.mt-8(no-gutters)
          v-col.pa-3(cols="3")
            div.text-sm.font-semibold.neutral700--text Remark
            v-textarea.text-sm.mt-2.round-xl(v-model="invoice.notes" placeholder="Enter your remark here" outlined rows="3" hide-details="auto")

          v-col.pa-3(cols="5")
            div.d-flex.align-center
              div.text-sm.font-semibold.neutral700--text Attachment
              v-spacer
              div.file-layout(v-if="selectedFiles.length")
                y-button(label="Add files" outlined size="xs" button-class="px-2" append-icon="$yzi-upload-01" icon-size="15")
                input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 92px !important" multiple="multiple")
            v-card.round-xl.mt-2(v-if="selectedFiles.length" outlined style="border-style: solid; border-color: var(--v-neutral400)")
              v-simple-table
                thead
                  tr
                    th.text-xs Name
                    th.text-xs(style="width: 120px;") Upload date
                    th.text-xs File type
                    th.text-xs
                tbody
                  tr(v-for="(file, index) in selectedFiles" :key="index")
                    td.text-sm.py-2(style="word-break: break-word;") {{ file.name }}
                    td.text-sm {{ getTodayDate() }}
                    td.text-sm {{ file.type }}
                    td.text-sm 
                      v-btn(small icon @click="removeFile(index)")
                        v-icon(size="18") $yzi-trash-03

            v-card.round-xl.pa-8.mt-2(v-else link outlined style="border-style: dashed; border-color: var(--v-neutral400)")
              .text-center
                v-avatar.mb-3(color="neutral300" size="40")
                  v-icon(color="neutral500" size="18") $yzi-upload-01
                .mb-1.text-sm 
                  span.font-semibold.info--text Click to upload 
                  | or drag and drop
                .text-xs.neutral500--text PDF, DOCS, JPG, PNG (max. 4MB)
              input.input-change-layout(ref="file" type="file" accept="image/png,image/jpeg,.pdf,.doc" multiple @change="onFileChange")

          v-col.pa-3(cols="3" offset="1" @click.stop)
            v-row(no-gutters)
              v-col.text-left.pl-4
                .text-sm.neutral700--text {{ $t('subtotal') }}
              v-col.text-right
                .text-sm.neutral700--text {{ (invoiceSubtotalAmount || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  template(v-if="invoice.adjustment_amount && invoice.adjustment_amount !== 0")
                    div.text-sm Adjustment
                    v-btn.ml-2(x-small icon @click="clearAmount('adjustment_amount')")
                      v-icon(small) mdi-close
                  template(v-else)
                    a.text-sm.font-semibold.underline.clickable(@click="showInputField('editAdjustment')") {{ $t('add_adjustment') }}
              v-col.text-right
                v-text-field.text-sm.round-xl(v-if="editAdjustment" v-model="invoice.adjustment_amount" placeholder="0.00" autofocus outlined dense height="48" type="number" :prefix="$currency.symbol" hide-details @blur="updateInput('editAdjustment', 'adjustment_amount')")
                .text-sm.neutral700--text(v-else) {{ (invoice.adjustment_amount || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  template(v-if="invoice.tax_amount && invoice.tax_amount !== 0")
                    div.text-sm tax
                    v-btn.ml-2(x-small icon @click="clearAmount('tax_amount')")
                      v-icon(small) mdi-close
                  template(v-else)
                    a.text-sm.font-semibold.underline.clickable(@click="showInputField('editTax')") Add tax
              v-col.text-right
                v-text-field.text-sm.round-xl(v-if="editTax" v-model="invoice.tax_amount" placeholder="0.00" autofocus outlined dense height="48" type="number" :prefix="$currency.symbol" hide-details @blur="updateInput('editTax', 'tax_amount')")
                .text-sm.neutral700--text(v-else) {{ (invoice.tax_amount || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  template(v-if="invoice.shipping_fee && invoice.shipping_fee !== 0")
                    div.text-sm Delivery charge
                    v-btn.ml-2(x-small icon @click="clearAmount('shipping_fee')")
                      v-icon(small) mdi-close
                  template(v-else)
                    a.text-sm.font-semibold.underline.clickable(@click="showInputField('editShippingFee')") Add delivery charge
              v-col.text-right
                v-text-field.text-sm.round-xl(v-if="editShippingFee" v-model="invoice.shipping_fee" placeholder="0.00" autofocus outlined dense height="48" type="number" :prefix="$currency.symbol" hide-details @blur="updateInput('editShippingFee', 'shipping_fee')")
                .text-sm.neutral700--text(v-else) {{ (invoice.shipping_fee || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  .text-lg.font-semibold.neutral700--text {{$t('total') }}
              v-col.text-right
                .text-lg.font-semibold.neutral700--text {{ invoiceTotalAmount | displayPrice }}

    v-footer.white(app inset padless elevation="3")
      v-container.px-10(fluid)
        div.d-flex.align-center
          v-spacer
          v-btn.button-md.underline.mr-4(text @click.stop="goBack") {{ $t('cancel') }}
          v-btn.button-md(color="neutral700" depressed dark :loading="isLoading" @click.stop="saveData") {{ $t('save') }}

    .dialogs
      error-stock-update-dialog(v-if="openErrorDialog" :open.sync="openErrorDialog" :stocks="errorStocks" :invoice="createdInvoice" @closed="goBack")
    
  </template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { isFileSizeOverLimit } from '@/utils'
import MedicationSoldByDropdown from '@/components/clinic/inventory/MedicationSoldByDropdown.vue'
import MedicationStockDropdown from '@/components/clinic/inventory/MedicationStockDropdown.vue'
import ErrorStockUpdateDialog from '@/components/clinic/inventory/ErrorStockUpdateDialog.vue'

export default {
  name: 'StockUpdate',
  components: { MedicationSoldByDropdown, MedicationStockDropdown, ErrorStockUpdateDialog },
  data() {
    return {
      isLoading: false,
      showInvoicePicker: false,
      openErrorDialog: false,
      editAdjustment: false,
      editTax: false,
      editShippingFee: false,
      showSellerError: false,
      invoiceDateField: null,
      createdInvoice: null,
      errorStocks: [],
      seller: {},
      invoice: {},
      selectedFiles: [],
      stocks: [{ editable: false, showExpiredPicker: false }],
      headers: [
        { text: '#', value: 'number', width: 40 },
        { text: 'Name', value: 'name'},
        { text: 'Qty', value: 'quantity', width: '8%' },
        { text: 'Rate', value: 'rate', width: '10%' },
        { text: 'UOM', value: 'uom', width: '10%' },
        { text: 'Exp date', value: 'expiry_date', width: '15%' },
        { text: 'Batch number', value: 'batch_no', width: '15%' },
        { text: 'Total Amount', value: 'total', width: '13%' },
        { text: '', value: 'action', width: 72 },
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({ company: 'getCompany' }),
    requiredInvoice () {
      let required = false
      if (Object.values(this.invoice).find(f => f)) {
        required = true
      }
      if (this.selectedFiles.length) {
        required = true
      }
      return required
    },
    invoiceSubtotalAmount () {
      let subtotal = 0
      this.stocks.forEach(stock => {
        if (stock.total) {
          subtotal += Math.round(Number(stock.total) * this.$currency.multiplier)
        }
      })
      return subtotal
    },
    invoiceTotalAmount () {
      let total = 0
      if (this.invoice.adjustment_amount && !this.editAdjustment) { total += this.invoice.adjustment_amount }
      if (this.invoice.tax_amount && !this.editTax) { total += this.invoice.tax_amount }
      if (this.invoice.shipping_fee && !this.editShippingFee) { total += this.invoice.shipping_fee }
      if (this.invoiceSubtotalAmount) {
        total += this.invoiceSubtotalAmount
      }
      return total
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (isFileSizeOverLimit(files[0], 5)) {
        this.showMessage(['error', this.$t('error_message.file_reached_limit')])
        return
      }
      files.forEach(o => {
        this.selectedFiles.push(o)
      })
    },
    async saveData () {
      this.closeEditable()
      this.closeEditableInvoice()
      if (!this.$refs.form.validate() || this.stocks.find(f => f.editable) || (this.requiredInvoice && Object.keys(this.seller).length == 0)) {
        if (this.requiredInvoice && Object.keys(this.seller).length == 0) {
          this.showSellerError = true
        }
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let inventoryIds = []
      let inventoryDatas = []
      let inventoryResps = []
      for (const stock of this.stocks) {
        if (!stock.medicine || !stock.quantity || !stock.rate) { continue }
        let data = {
          action: 'received',
          change: stock.quantity,
          cost: Math.round(Number(stock.total) * Number(this.$currency.multiplier))
        }
        if (stock.batch_no) { data.batch_no = stock.batch_no }
        if (stock.expiryDateField) { data.expiry_date = stock.selectedExpiryDate }
        await this.$axios.post(`/products/${stock.medicine.product.id}/inventories`, data)
          .then(resp => {
            inventoryIds.push(resp.data.id)
            inventoryResps.push(resp.data)
            inventoryDatas.push(data)
          })
          .catch(err => {
            let message = 'Error updating stock'
            if (err.response.data) {
              if (err.response.data?.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            let errObj = { 
              message: message,
              stock: stock
            }
            this.errorStocks.push(errObj)
          })
      }
      if (this.requiredInvoice && inventoryIds.length) {
        let payload = { ...this.invoice }
        payload.product_inventory_ids = inventoryIds
        payload.seller = this.seller.sold_by
        let inventoryInvoiceId = null
        await this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/`, payload)
          .then(resp2 => { 
            inventoryInvoiceId = resp2.data.id
            this.createdInvoice = resp2.data
          })
          .catch(() => {
            let message = 'Error creating invoice'
            this.showMessage(['error', message])
          })
        if (this.selectedFiles.length) {
          for (const file of this.selectedFiles) {
            const formData = new FormData()
            formData.append('doc_type', 'invoice')
            formData.append('file', file)
            await this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/${inventoryInvoiceId}/documents`, formData)
              .catch(() => {
                let message = 'Error attach documents'
                this.showMessage(['error', message])
              })
          }
        }
      }
      this.updateActivityLog('/products/<product_id>/inventories', inventoryDatas, inventoryResps, 'POST',`Bulk stock update`, inventoryIds.join())
      this.isLoading = false
      if (this.errorStocks.length) {
        this.openErrorDialog = true
      } else {
        this.goBack()
      }
    },
    pickDate (field, picker, date) {
      this[field] = this.$options.filters.humanizeDate(date)
      this[picker] = false
    },
    pickItemDate (item) {
      item.expiryDateField = this.$options.filters.humanizeDate(item.selectedExpiryDate)
      item.showExpiredPicker = false
    },
    clickRow (item) {
      this.closeEditable()
      item.editable = true
    },
    clickOutside () {
      this.closeEditableInvoice()
      this.closeEditable()
      const notFullRow = this.stocks.find(f => !f.medicine || !f.quantity || !f.rate || !f.total)
      const emptyRow = this.stocks.find(f => !f.medicine && !f.quantity && !f.rate && !f.total && !f.expiry_date && !f.batch_no)
      if (!emptyRow && !notFullRow) {
        this.stocks.push({ editable: false, showExpiredPicker: false })
      }
    },
    closeEditable () {
      return this.stocks.map(m => {
        if (m.medicine && m.quantity && m.rate && m.total) {
          m.editable = false
        } else if (!m.medicine && !m.quantity && !m.rate && !m.total && !m.expiry_date && !m.batch_no) {
          m.editable = false
        }
      })
    },
    closeEditableInvoice () {
      this.editAdjustment = false
      this.editTax = false
      this.editShippingFee = false
    },
    isCompletedItem (item) {
      if (!item.editable && item.medicine && item.quantity && item.rate && item.total) {
        return true
      }
      return false
    },
    showInputField (field) {
      this.closeEditableInvoice()
      this[field] = true
    },
    updateInput (field, amount) {
      if (!this.invoice[amount]) { return }
      this.invoice[amount] = Math.round(this.invoice[amount] * this.$currency.multiplier)
      this[field] = false
    },
    deleteItem (idx) {
      this.stocks.splice(idx, 1)
    },
    removeFile (idx) {
      this.selectedFiles.splice(idx, 1)
    },
    clearAmount (field) {
      this.$set(this.invoice, field, 0)
    },
    calculateAmount (item, type) {
      if (type === 'rate' && item.rate) {
        if (item.quantity) {
          item.total = (item.rate * item.quantity).toFixed(2)
        } else if (item.total) {
          item.total = null
        }
      } else if (type === 'total' && item.total) {
        if (item.quantity) {
          item.rate = (item.total / item.quantity).toFixed(2)
        } else if (item.rate) {
          item.rate = null
        }
      } else if (type === 'quantity' && item.quantity) {
        if (item.rate) {
          item.total = (item.rate * item.quantity).toFixed(2)
        } else if (item.total) {
          item.rate = (item.total / item.quantity).toFixed(2)
        }
      }
    },
    getTodayDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return this.$options.filters.humanizeDate(`${year}-${month}-${day}`)
    },
    goBack () {
      this.$router.push('/admin/clinic/inventory')
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'inventory',
        activity: activity,
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
.custom-width {
  width: 50px !important;
}
.item-custom-style {
  display:grid;
  align-content: center;
  height: 60px;
  cursor: pointer;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
  cursor: pointer;
}
</style>